// ArtifactsTab.js
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { fetchArtifactsData, dateTemplate, clients } from './DataFlow';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';

const ArtifactsTab = () => {
    const [artifactsData, setArtifactsData] = useState([]);
    const [artifactRows, setArtifactRows] = useState(5);
    const [artifactsFirst, setArtifactsFirst] = useState(0);
    const [filters, setFilters] = useState({
        gameName: { value: null, matchMode: FilterMatchMode.EQUALS },
        branch: { value: null, matchMode: FilterMatchMode.CONTAINS },
        pureVersion: { value: null, matchMode: FilterMatchMode.CONTAINS },
        version: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    useEffect(() => {
        fetchArtifactsData(setArtifactsData);
    }, [artifactsFirst, artifactRows]);

    const onArtifactsPageChange = (e) => {
        setArtifactsFirst(e.first);
        setArtifactRows(e.rows);
    };

    const clientFilterTemplate = (options) => (
        <Dropdown
            value={options.value}
            options={clients}
            onChange={(e) => options.filterCallback(e.value)}
            placeholder="Filter by project"
            className="p-column-filter"
            showClear
        />
    );

    const textFilterTemplate = (options) => (
        <InputText
            type="text"
            value={options.value || ''}
            onChange={(e) => options.filterCallback(e.target.value)}
            placeholder="Filter..."
            className="p-column-filter"
        />
    );

    return (
        <DataTable 
            value={artifactsData} 
            first={artifactsFirst} 
            paginator 
            rows={artifactRows} 
            onPage={onArtifactsPageChange} 
            rowsPerPageOptions={[5, 10, 20]} 
            sortOrder={-1} 
            className="dark-table"
            filters={filters}
            filterDisplay="menu"
            showGridlines
        >
            <Column 
                field="gameName" 
                header="Project" 
                filter 
                filterElement={clientFilterTemplate}
                filterPlaceholder="Filter by project"
            />
            <Column 
                field="branch" 
                header="Branch" 
                filter 
                filterElement={textFilterTemplate}
                filterPlaceholder="Filter by branch"
            />
            <Column 
                field="pureVersion" 
                header="Pure Version" 
                filter 
                filterElement={textFilterTemplate}
                filterPlaceholder="Filter by pure version"
            />
            <Column 
                field="version" 
                header="Version" 
                filter 
                filterElement={textFilterTemplate}
                filterPlaceholder="Filter by version"
            />
            <Column 
                field="creationDate" 
                header="Date" 
                sortable 
                body={dateTemplate}
            />
        </DataTable>
    );
};

export default ArtifactsTab;
